"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var ResultInfo =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ResultInfo, _React$Component);

  function ResultInfo() {
    (0, _classCallCheck2.default)(this, ResultInfo);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ResultInfo).apply(this, arguments));
  }

  (0, _createClass2.default)(ResultInfo, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          gradeType = _this$props.gradeType,
          localizedTextKey = _this$props.localizedTextKey;
      return _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "result-text-small"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: localizedTextKey + ".result.title." + gradeType
      })), _react.default.createElement("div", {
        className: "result-description"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: localizedTextKey + ".result.description"
      })));
    }
  }]);
  return ResultInfo;
}(_react.default.Component);

exports.default = ResultInfo;
ResultInfo.propTypes = {
  localizedTextKey: _propTypes.default.string,
  gradeType: _propTypes.default.string
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/result/ResultInfo.js
// module id = 69
// module chunks = 0